import Api from '../api';
import { errorHandler } from '../common';
const { axios: api } = Api;
export const getTranslationByLang = (userId) =>
	errorHandler(async () => {
		const data = await api.get(`/translation/${userId}`);
		return { data: data.data };
	});

export const addNewTranslation = (word) =>
	errorHandler(async () => {
		const data = await api.post(`/translation/`, { word: word });
		return { data: data.data };
	});

export const findTranslation = (text) =>
	errorHandler(async () => {
		const data = await api.get(`/translation/search/${text}`);
		return { data: data.data };
	});

export const updateTranslation = (id, label) =>
	errorHandler(async () => {
		const data = await api.patch(`/translation/${id}/${label}`);
		return { data: data.data };
	});
